(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  var autoplayTimer = null;

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function getCarouselWidget() {
    return document.querySelector('#stamped-reviews-widget[data-widget-type="carousel"]');
  }

  function captureAutoplaySettings(widget) {
    if (!widget || widget.dataset.imperiaAutoplayCaptured === '1') return;

    var speed = parseInt(
      widget.getAttribute('data-auto-play-speed') || widget.dataset.autoPlaySpeed,
      10
    );
    widget.dataset.imperiaAutoplaySpeed = String(
      isNaN(speed) || speed < 1000 ? 5000 : speed
    );
    widget.dataset.imperiaAutoplayEnabled = '1';
    widget.dataset.imperiaAutoplayCaptured = '1';
  }

  function suppressStampedAutoplay(widget) {
    if (!widget || !isMobile()) return;
    captureAutoplaySettings(widget);
    widget.setAttribute('data-auto-play', 'false');
    widget.dataset.autoPlay = 'false';
  }

  function stopMobileAutoplay() {
    if (autoplayTimer) {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function startMobileAutoplay(widget) {
    stopMobileAutoplay();
    if (!widget || !isMobile()) return;
    if (widget.dataset.imperiaAutoplayEnabled !== '1') return;
    if (!widget.querySelector('.stamped-carousel-scroll-wrapper .block')) return;

    var speed = parseInt(widget.dataset.imperiaAutoplaySpeed, 10) || 5000;
    autoplayTimer = window.setInterval(function () {
      if (!isMobile()) {
        stopMobileAutoplay();
        return;
      }
      mobileSwitchSlide(widget, 1);
    }, speed);
  }

  function getBlocks(wrapper) {
    return Array.prototype.filter.call(wrapper.children, function (node) {
      return node.nodeType === 1 && node.classList.contains('block');
    });
  }

  function goToSlide(widget, wrapper, pageWidth, index, animate) {
    var blocks = getBlocks(wrapper);
    if (!blocks.length || !pageWidth) return;

    if (index < 0) index = blocks.length - 1;
    if (index >= blocks.length) index = 0;

    widget.dataset.imperiaSlideIndex = String(index);
    wrapper.style.setProperty(
      'transition',
      animate ? 'left 0.45s ease-in-out' : 'none',
      'important'
    );
    wrapper.style.setProperty('left', -index * pageWidth + 'px', 'important');
  }

  function applyMobileLayout(widget, resetPosition) {
    if (!isMobile() || !widget) return 0;

    suppressStampedAutoplay(widget);

    var scroll = widget.querySelector('.stamped-carousel-scroll');
    var wrapper = widget.querySelector('.stamped-carousel-scroll-wrapper');
    if (!scroll || !wrapper) return 0;

    var pageWidth = scroll.clientWidth;
    if (!pageWidth) return 0;

    scroll.style.setProperty('overflow', 'hidden', 'important');
    scroll.style.setProperty('position', 'relative', 'important');

    wrapper.style.setProperty('display', 'flex', 'important');
    wrapper.style.setProperty('flex-wrap', 'nowrap', 'important');
    wrapper.style.setProperty('width', 'max-content', 'important');
    wrapper.style.setProperty('position', 'relative', 'important');
    wrapper.style.setProperty('transition-property', 'left', 'important');

    getBlocks(wrapper).forEach(function (block) {
      block.style.setProperty('width', pageWidth + 'px', 'important');
      block.style.setProperty('min-width', pageWidth + 'px', 'important');
      block.style.setProperty('max-width', pageWidth + 'px', 'important');
      block.style.setProperty('flex', '0 0 ' + pageWidth + 'px', 'important');
      block.style.setProperty('box-sizing', 'border-box', 'important');
      block.style.setProperty('opacity', '1', 'important');
      block.style.setProperty('visibility', 'visible', 'important');
      block.style.setProperty('transition', 'none', 'important');
    });

    if (resetPosition) {
      goToSlide(widget, wrapper, pageWidth, 0, false);
    } else {
      var index = parseInt(widget.dataset.imperiaSlideIndex, 10);
      if (isNaN(index)) index = 0;
      goToSlide(widget, wrapper, pageWidth, index, false);
    }

    return pageWidth;
  }

  function getCurrentIndex(widget) {
    var stored = parseInt(widget.dataset.imperiaSlideIndex, 10);
    return isNaN(stored) ? 0 : stored;
  }

  function mobileSwitchSlide(widget, direction) {
    if (!widget) widget = getCarouselWidget();
    if (!widget || !isMobile()) return;

    var scroll = widget.querySelector('.stamped-carousel-scroll');
    var wrapper = widget.querySelector('.stamped-carousel-scroll-wrapper');
    if (!scroll || !wrapper) return;

    var pageWidth = applyMobileLayout(widget, false);
    if (!pageWidth) return;

    var blocks = getBlocks(wrapper);
    if (!blocks.length) return;

    var nextIndex = getCurrentIndex(widget) + direction;
    goToSlide(widget, wrapper, pageWidth, nextIndex, true);
  }

  function patchStampedCarouselFn() {
    if (!window.StampedCarouselFn || typeof window.StampedCarouselFn.switchSlide !== 'function') {
      return false;
    }

    if (window.StampedCarouselFn.__imperiaMobilePatched) {
      return true;
    }

    var originalSwitch = window.StampedCarouselFn.switchSlide;
    var originalInit = window.StampedCarouselFn.init;

    window.StampedCarouselFn.switchSlide = function (trigger, direction) {
      if (isMobile()) {
        mobileSwitchSlide(getCarouselWidget(), direction);
        return;
      }
      return originalSwitch.apply(this, arguments);
    };

    if (typeof originalInit === 'function') {
      window.StampedCarouselFn.init = function () {
        var capturedTimers = [];
        var originalSetInterval = window.setInterval;

        if (isMobile()) {
          window.setInterval = function (handler, timeout) {
            var id = originalSetInterval.apply(this, arguments);
            if (typeof timeout === 'number' && timeout >= 1000) {
              capturedTimers.push(id);
            }
            return id;
          };
        }

        var result = originalInit.apply(this, arguments);

        if (isMobile()) {
          window.setInterval = originalSetInterval;
          capturedTimers.forEach(function (id) {
            window.clearInterval(id);
          });
          applyMobileLayout(getCarouselWidget(), true);
          startMobileAutoplay(getCarouselWidget());
        }

        return result;
      };
    }

    window.StampedCarouselFn.__imperiaMobilePatched = true;
    return true;
  }

  function initCarouselMobile() {
    var widget = getCarouselWidget();
    if (!widget) return;

    suppressStampedAutoplay(widget);
    patchStampedCarouselFn();

    if (!widget.querySelector('.stamped-carousel-scroll-wrapper .block')) return;

    var needsReset = widget.dataset.imperiaLayoutApplied !== '1';
    applyMobileLayout(widget, needsReset);

    if (needsReset) {
      widget.dataset.imperiaLayoutApplied = '1';
      startMobileAutoplay(widget);
    }
  }

  function observeCarousel() {
    var widget = getCarouselWidget();
    if (!widget) return;

    initCarouselMobile();

    if (widget.dataset.imperiaCarouselObserved === '1') return;
    widget.dataset.imperiaCarouselObserved = '1';

    var observer = new MutationObserver(function () {
      initCarouselMobile();
    });

    observer.observe(widget, { childList: true, subtree: true });
  }

  function boot() {
    var widget = getCarouselWidget();
    captureAutoplaySettings(widget);
    suppressStampedAutoplay(widget);
    patchStampedCarouselFn();
    observeCarousel();

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      initCarouselMobile();
      if (tries > 80) window.clearInterval(timer);
    }, 250);

    window.addEventListener('resize', function () {
      var w = getCarouselWidget();
      if (!w || !isMobile()) return;
      applyMobileLayout(w, false);
    });

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', function () {
        var w = getCarouselWidget();
        if (!w) return;
        stopMobileAutoplay();
        w.dataset.imperiaLayoutApplied = '0';
        initCarouselMobile();
        if (isMobile()) startMobileAutoplay(w);
      });
    }

    document.addEventListener('visibilitychange', function () {
      var w = getCarouselWidget();
      if (!w || !isMobile()) return;
      if (document.hidden) stopMobileAutoplay();
      else startMobileAutoplay(w);
    });

    document.addEventListener('stamped:widget:reloading', function () {
      var w = getCarouselWidget();
      stopMobileAutoplay();
      if (w) {
        w.dataset.imperiaLayoutApplied = '0';
        w.dataset.imperiaCarouselObserved = '0';
        w.dataset.imperiaSlideIndex = '0';
        w.dataset.imperiaAutoplayCaptured = '0';
      }
      window.setTimeout(observeCarousel, 600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
})();
